import { ShareIcon } from '@blocksuite/icons/rc';
import type { MenuItemProps } from '@pique/component';
import { MenuItem } from '@pique/component';
import { useI18n } from '@pique/i18n';

export const DisablePublicSharing = (props: MenuItemProps) => {
  const t = useI18n();
  return (
    <MenuItem type="danger" prefixIcon={<ShareIcon />} {...props}>
      {t['Disable Public Sharing']()}
    </MenuItem>
  );
};
